// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
tr.sub-table-row td {
  background-color: rgba(28, 115, 186, 0.1) !important;
}

@media (max-width: 1366px) {
  :host ::ng-deep .p-datatable .p-datatable-tbody tr th {
    padding: 12px 8px;
  }
}
:host ::ng-deep .p-datatable .p-datatable-tbody tr td {
  width: 15%;
}
:host ::ng-deep .p-datatable .p-datatable-tbody tr td:first-child {
  width: 20%;
}
:host ::ng-deep .p-datatable .p-datatable-tbody tr td:last-child {
  width: 10%;
}
@media (max-width: 1366px) {
  :host ::ng-deep .p-datatable .p-datatable-tbody tr td {
    width: 14.5%;
    padding: 12px 8px;
  }
  :host ::ng-deep .p-datatable .p-datatable-tbody tr td:first-child {
    width: 19%;
    overflow-wrap: anywhere;
  }
  :host ::ng-deep .p-datatable .p-datatable-tbody tr td:last-child {
    width: 8.5%;
  }
}
:host ::ng-deep .p-datatable .p-datatable-tbody tr td .gc-agency-handle {
  width: 160px;
}
:host ::ng-deep .p-datatable .p-datatable-tbody tr td.leftBoder-4 {
  border-left: 4px solid #0A6ED9 !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/colors.scss","webpack://./src/app/episode/episode.component.scss"],"names":[],"mappings":"AAAA;;EAAA;ACEI;EACI,oDAAA;AAER;;AAMQ;EADF;IAEI,iBAAA;EAFR;AACF;AAIM;EACE,UAAA;AAFR;AAGQ;EACE,UAAA;AADV;AAGQ;EACE,UAAA;AADV;AAGQ;EARF;IASI,YAAA;IACA,iBAAA;EAAR;EACQ;IACE,UAAA;IACA,uBAAA;EACV;EACQ;IACE,WAAA;EACV;AACF;AACQ;EACE,YAAA;AACV;AACQ;EACE,yCAAA;AACV","sourcesContent":["/**\n * Created by Inzamam Janjua on 18/05/2023.\n */\n\n\n// Primary Color Palette\n\n$primaryBlue: #0A6ED9;\n$GreenBlue: #1C75BC;\n$Orange: #EF896A;\n$DarkSilver: #6C6D70;\n$BrightYellow: #F9A51D;\n$Green: #6ACE6A;\n$Greenlight: #7AEC7A;\n$GreenDark: #5CB85C;\n$white: #fff;\n$black: #000;\n$red:#C66A9E;\n// Standard System Colors\n\n$errorRed: #FF3C3C;\n$darkRed: #C11574;\n$lightRed: #FDF2FA;\n$successGreen: #10B981;\n$lightGreen: #ECFAF5;\n$lightOrange: #FFF2EB;\n$notificationYellow: #F9A51D;\n$lightBlue:rgba(226, 238, 255, 1);\n$headingText: #1E38A9;\n","@import \"../../assets/styles/colors.scss\";\ntr.sub-table-row{\n    td{\n        background-color: rgb(28 115 186 / 10%) !important;\n    }\n}\n:host ::ng-deep\n.p-datatable {\n  .p-datatable-tbody {\n    tr {\n      th{\n        @media(max-width:1366px) {\n          padding: 12px 8px;\n        }\n      }\n      td{\n        width: 15%;\n        &:first-child {\n          width: 20%;\n        }\n        &:last-child {\n          width: 10%;\n        }\n        @media(max-width:1366px) {\n          width: 14.5%;\n          padding: 12px 8px;\n          &:first-child {\n            width: 19%;\n            overflow-wrap: anywhere;\n          }\n          &:last-child {\n            width: 8.5%;\n          }\n        }\n        .gc-agency-handle{\n          width: 160px;\n        }\n        &.leftBoder-4{\n          border-left: 4px solid $primaryBlue !important;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
